import type { UserSettings } from "~/common/interfaces/entities/user-settings.interface";

export const getUserSettingsDefault = (): UserSettings => ({
	id: 0,
	telegramId: "",
	telegramNotifications: false
});
